import {TargetAccount} from './target.model';
import {
  createAction,
  createFeatureSelector,
  createReducer,
  createSelector,
  on,
  props as actionProps
} from '@ngrx/store';
import {Segment} from '../segment/segment.model';

export interface TargetState {
  targets: TargetAccount[],
  targetsIndex: { [id: string]: TargetAccount }
}


export const initialState: Readonly<TargetState> = {targets: [], targetsIndex: {}};

// selectors
export const targetsFeatureSelector = createFeatureSelector<TargetState>('targetsSlice');
export const selectTargetById = (id: string) => createSelector(
  targetsFeatureSelector,
  (state) => state.targetsIndex[id]
);
export const selectTargets = createSelector(
  targetsFeatureSelector,
  (state) => state.targets
);
export const selectAccounts = createSelector(
  targetsFeatureSelector,
  (state) => state.targets.flatMap(it => it.accounts)
);

// actions
export const loadTargets = createAction(
  '[Targets] Load targets'
);
export const targetsLoaded = createAction(
  '[Targets] Loaded targets',
  actionProps<{ targets: TargetAccount[] }>()
);
export const targetUnshared = createAction(
  '[Targets] Target unshared from segment',
  actionProps<{ segment: Segment }>()
);
export const targetsReducer = createReducer(
  initialState,
  on(targetsLoaded, (state, {targets}) => {
    const index = targets.reduce((accumulator, current) => {
      return {
        ...accumulator,
        [current.targetId]: current
      };
    }, {});
    return {
      ...state,
      targets,
      targetsIndex: index
    } as TargetState;
  })
);
